import { cloneConfig } from '@/schema/legacy-adapter'
import { createPageId } from '@/schema/page-project'
import { cloneNodes } from './node-operations'

function walk (nodes, visit) {
  nodes.forEach(node => { visit(node); if (Array.isArray(node.children)) walk(node.children, visit) })
}

function allocateId (create, used, label) {
  for (let attempt = 0; attempt < 20; attempt++) {
    const id = create()
    if (typeof id !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(id)) throw new Error(label + '编号生成失败，请重试')
    if (!used.has(id)) { used.add(id); return id }
  }
  throw new Error(label + '编号重复，请重试')
}

function copyName (source, pages) {
  const names = new Set(pages.map(page => page.name))
  for (let number = 1; ; number++) {
    const suffix = ' - 副本' + (number === 1 ? '' : ' ' + number)
    const name = source.slice(0, 60 - suffix.length).trimEnd() + suffix
    if (!names.has(name)) return name
  }
}

// 复制原页面全部配置，不使用资源模板白名单裁剪已有组件、绑定或扩展字段。
export function createPageCopy (project, source, createNodeId, createPage = createPageId, limits = {}) {
  const maxPages = limits.maxPages || 100, maxNodes = limits.maxNodes || 3000
  if (project.pages.length >= maxPages) throw new Error('项目最多支持 ' + maxPages + ' 个页面，无法继续复制')
  const usedNodes = new Set(), sourceIds = new Set()
  let total = 0, sourceCount = 0
  project.pages.forEach(page => walk(page.id === source.id ? source.nodes : page.nodes, node => { usedNodes.add(node.index); total++ }))
  walk(source.nodes, node => {
    if (node.index === undefined || node.index === null || String(node.index) === '' || sourceIds.has(node.index)) throw new Error('页面组件编号为空或重复，请先修复后再复制')
    sourceIds.add(node.index); sourceCount++
  })
  if (total + sourceCount > maxNodes) throw new Error('复制后项目组件总数超过 ' + maxNodes + '，请减少组件后重试')
  const page = cloneConfig(source)
  page.id = allocateId(createPage, new Set(project.pages.map(item => item.id)), '页面')
  page.name = copyName(source.name, project.pages)
  page.config.name = page.name
  page.nodes = cloneNodes(source.nodes, () => allocateId(createNodeId, usedNodes, '组件'), { x: 0, y: 0 }, { preserveLocks: true })
  walk(page.nodes, node => {
    const action = node.navigation
    if (action && action.type === 'page' && action.pageId === source.id) action.pageId = page.id
    if (action && action.type === 'product') {
      if (Array.isArray(action.routes)) action.routes.forEach(route => {
        if (route && route.pageId === source.id) route.pageId = page.id
      })
      if (action.fallback && action.fallback.type === 'page' && action.fallback.pageId === source.id) action.fallback.pageId = page.id
    }
  })
  return page
}
